import { useNavigate } from "react-router-dom";
import { AppRoute } from "../../interfaces/app-routes";
import MaterialIcon from "../../ui-elements/material-icon/material-icon";
import styles from "./profile-menu.module.scss";

interface IProfileMenuProps {
  show: boolean;
  onClose: () => void;
  onLogout: () => void;
}

const ProfileMenu = ({ show, onClose, onLogout }: IProfileMenuProps) => {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles["profile-menu"]}>
        <div
          className={styles["menu-item"]}
          onClick={() => navigate(AppRoute.PROFILE_DETAILS)}
        >
          <MaterialIcon icon="person_outline" className={styles.icon} />
          <div className={styles.content}>
            <div className={styles.title}>Profile Details</div>
          </div>
          <MaterialIcon icon="chevron_right" className={styles.arrow} />
        </div>

        <div
          className={styles["menu-item"]}
          onClick={() => navigate(AppRoute.THEME)}
        >
          <MaterialIcon icon="contrast" className={styles.icon} />
          <div className={styles.content}>
            <div className={styles.title}>Theme</div>
          </div>
          <MaterialIcon icon="chevron_right" className={styles.arrow} />
        </div>

        <div className={styles["menu-item"]} onClick={onLogout}>
          <MaterialIcon icon="logout" className={styles["logout-icon"]} />
          <div className={`${styles.content} ${styles.logout}`}>Logout</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
